import { kFavIcon, kFavIconNotif } from "../whitelabel/brand";
import { getImagePath } from "./getImagePath";
import { isMfeContext } from "./isMfeContext";

export function updateFavicon(doAlert: boolean): void {
  // The MFE shares the host page's document — it must never override the
  // host's own tab favicon.
  if (isMfeContext()) return;
  const link = document.createElement("link");
  const oldLink = document.getElementById("dynamic-favicon");
  link.id = "dynamic-favicon";
  link.rel = "shortcut icon";
  link.href = getImagePath(doAlert ? kFavIconNotif : kFavIcon);
  if (oldLink) {
    document.head.removeChild(oldLink);
  }
  document.head.appendChild(link);
}
